import React from 'react';

import { FormikProps, useField } from 'formik';

const FormItem: React.FC<{
  formGroupProps?: any;
  label?: string;
  labelProps?: any;
  for?: string;
  name?: string;
  form?: FormikProps<any>;
  className?: string;
  labelClassNames?: string;
  formControlClassName?: string;
  formControlProps?: any;
  helpText?: string;
}> = (props) => {
  const [, meta] = useField({ name: props.name || 'UNKNOWN' });

  return (
    <div
      className={`form-group ${meta?.error && meta?.touched ? 'has-error' : ''} ${
        props.className || ''
      }`}
      {...props.formGroupProps}
    >
      {props.label ? (
        <label
          htmlFor={props.for}
          className={`${props.labelClassNames || 'col-sm-4 col-md-3'} control-label`}
          {...props.labelProps}
        >
          {props.label}
        </label>
      ) : null}
      <div
        className={props.formControlClassName || 'col-sm-8 col-md-9'}
        {...props.formControlProps}
      >
        {props.children}
        {meta?.error && meta?.touched && <span className="help-block">{meta?.error}</span>}
        {props.helpText && <span className="help-block">{props.helpText}</span>}
      </div>
    </div>
  );
};

export default FormItem;
